(function (algolia) {
  // Function to create random user token if one isn't found
  function createRandomUserToken() {
    return Array.from(Array(20), () => Math.floor(Math.random() * 36).toString(36)).join('');
  }

  const insightsClient = window[window.AlgoliaAnalyticsObject];

  const enabled = algolia.config.analytics_enabled;
  if (!enabled || !insightsClient) return;

  // useCookie parameter set up
  const userTokenAdminSetting = algolia.config.usertoken_with_cookies === 'enabled';
  let useCookie = true;
  let userToken;

  if (window.SDG && window.SDG.user_id) {
    userToken = `customer-${window.SDG.user_id}`;
  } else {
    userToken = createRandomUserToken();
  }

  if (userTokenAdminSetting) {
    window.Shopify.loadFeatures(
      [
        {
          name: 'consent-tracking-api',
          version: '0.1',
        },
      ],
      (error) => {
        if (error) {
          console.error('Customer Privacy API Error', error);
        }
        const userCanBeTracked = window.Shopify.customerPrivacy
          ? window.Shopify.customerPrivacy.userCanBeTracked() : false;
        useCookie = userTokenAdminSetting && userCanBeTracked;
        insightsClient('init', {
          useCookie,
          partial: true,
          userToken,
        });
      },
    );
  } else {
    insightsClient('init', {
      useCookie,
      partial: true,
      userToken,
    });
  }
}(window.algoliaShopify));
